import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { User } from '@domain/interface/user';
import { Cargochief } from '@service/cargochief/cargochief.service';
import { SharedService } from '@service/shared/shared.service';
import { UtilService } from '@service/util/util.service';
import { UserRoleService } from '@service/userRole/user-role.service';
import { TEMPLATE_TYPE } from '@domain/constants/email-templates';
import { MediaObserver } from '@angular/flex-layout';

@Component({
	selector: 'app-sidenav-menu',
	templateUrl: './sidenav-menu.component.html',
	styleUrls: ['./sidenav-menu.component.scss'],
	encapsulation: ViewEncapsulation.None,
	// changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidenavMenuComponent implements OnInit {
	options: UntypedFormGroup;
	user: User;

	opened = true;
	over = 'side';
	expandHeight = '42px';
	collapseHeight = '42px';
	displayMode = 'flat';

	TEMPLATE_TYPE = TEMPLATE_TYPE;
	
	smallDeviceScreen: boolean = false;


	constructor(
		media: MediaObserver,
		fb: UntypedFormBuilder,
		private sharedService: SharedService,
		public cargochief: Cargochief,
		public utilService: UtilService,
		public userRoleService: UserRoleService
	) {
		this.options = fb.group({
			fixed: false,
			top: 0,
			bottom: 0,
		});
		this.utilService.isNullOrUndefined;

		
		media.asObservable().subscribe((change) => {
			this.smallDeviceScreen =
				change.filter((item) => item.mqAlias == 'xs' || item.mqAlias == 'sm')?.length > 0;
			let htmlTag = document.getElementById('html_container');
			if (htmlTag) {
				if (this.smallDeviceScreen) {
					htmlTag.classList.remove('html_container');
				} else {
					htmlTag.classList.add('html_container');
				}
			}
		});
	}

	ngOnInit() {
		this.user = this.cargochief.getUser();
		this.sharedService.getLayoutToggledValue().subscribe((data) => {
			this.opened = data;
		});
	}

	ngOnDestroy() {
	}
}
